import { useReactiveVar } from '@bestseller/retail-planning.utils.reactive-vars';
import { storefrontTypeVar } from 'src/infrastructure/local_state';

export const useStorefrontType = () => {
    const [storefrontType] = useReactiveVar(storefrontTypeVar);
    return storefrontType;
};
